import { Modal as AntModal } from "antd";
import styled from "styled-components";

export const Modal = styled(AntModal)`
  .ant-btn {
    margin-left: ${props => props.theme.spacersm};
  }
`;
